/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * @module markdown-gfm/markdown2html
 */

import marked from 'marked';

// Overrides.
marked.use( {
	tokenizer: {
		// Disable the autolink rule in the lexer.
		autolink: () => null,
		url: () => null
	}
} );

/**
 * Parses markdown string to an HTML.
 *
 * @param {String} markdown
 * @returns {String}
 */
export default function markdown2html( markdown ) {
	const data = marked.parse( markdown, {
		gfm: true,
		breaks: true,
		tables: true,
		xhtml: true,
		headerIds: false
	} );

	/**
	 * CKEditor 5's default configuration doesn't allow block-level elements such as <p> tags to be nested within inline elements like <li>.
	 * According to the HTML specification, <li> elements should contain flow content, but in practice,
	 * CKEditor 5 often treats each <li> as a block and expects inline content directly within it.
	 * This behavior can cause issues when trying to render nested paragraphs within list items.
	 *
	 * CKEditor 5 version 27.0, the General HTML Support plugin is not available, as it was introduced in version 29.0
	 *
	 * When marked is parsing the markdown data, sometimes getting line break (/n), so remove it.
	 */
	// const replaced = data.replaceAll("\n", "").replaceAll(/<li>(<p>|<h[1-6]>)(.*?)<\/(p|h[1-6])><\/li>/gi, '<li>$2</li>');
	const replaced = data
	.replaceAll("\n", "") // const replaced = data.replaceAll("\n", "");
	.replaceAll(/<li>(<p>|<h[1-6]>)/gi, '<li>')
	.replaceAll(/<\/(p|h[1-6])><\/li>/gi, '</li>');

	return replaced;
}

export { marked };
